import type { FC } from 'react';
import { WorkingOfAServletWrapper } from './WorkingOfAServlet.styled';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';

interface WorkingOfAServletProps { }

const WorkingOfAServlet: FC<WorkingOfAServletProps> = () => (
   <WorkingOfAServletWrapper>
      <header className="entry-header ">
         <h1 className="entry-title" itemProp="headline">Working of a Servlet</h1>
      </header>
      <br/>
      <div className="entry-content clear" itemProp="text" style={{ height: 'auto !important' }}>
         <h4 className="text-align-justify"><strong>Life Cycle of Servlet :</strong></h4>
         <ul className="text-align-justify">
            <li><strong>Loading :</strong>
               <ul>
                  <li>It is the responsibility of the classloader to load the servlet class. </li>
                  <li>When the web container receives the first request for the servlet, it loads the servlet class. </li>
                  <li>During this step, a Servlet container creates a ServletContext object. An interface that defines the set of methods that a servlet can use to communicate with the servlet container is known as ServletContext.</li>
               </ul>
            </li>
            <br/>
            <li><strong>Instantiation :</strong>
               <ul>
                  <li>After loading the servlet class, the web container creates the instance of a servlet. </li>
                  <li>The servlet life cycle creates the servlet instance only once.</li>
               </ul>
            </li>
            <br/>
            <li><strong>Initialization :</strong>
               <ul>
                  <li>The init method initializes the servlet.</li>
                  <li>The init method is responsible to create or load the data that will be used throughout the life of the servlet.</li>
                  <li>Syntax – public void init(ServletConfig config)</li>
               </ul>
            </li>
            <br/>
            <li><strong>Service :</strong>
               <ul>
                  <li>Each time the web container receives the request for the servlet, it calls the service method.</li>
                  <li>The service() method is the main method to perform the actual task i.e. to handle requests coming from the client and to write the formatted response back to the client.</li>
                  <li>The container calls the service method and this method invokes doGet, doPost, doPut, doDelete, etc. methods as appropriate.</li>
                  <li>Syntax – public void service(ServletRequest request, ServletResponse response) </li>
               </ul>
            </li>
            <br/>
            <li><strong>Destruction :</strong>
               <ul>
                  <li>It calls the destroy method only once at the end of the life cycle of a servlet.</li>
                  <li>The web container calls the destroy method before removing the servlet instance from the service to give a chance to –
                     <ul>
                        <li>clean up any resource</li>
                        <li>close database connections</li>
                        <li>halt background threads</li>
                        <li>write cookie lists</li>
                        <li>hit counts to disk</li>
                        <li>perform other such cleanup activities</li>
                     </ul>
                  </li>
                  <li>Syntax : public void destroy()  </li>
               </ul>
            </li>
         </ul>
         <br/>
         <h4  className="text-align-justify"><strong>Advantages of Servlet :</strong></h4>
         <ul  className="text-align-justify">
            <li>Better Performance as it works on threads.</li>
            <li>Portability</li>
            <li>Robust</li>
            <li>Secure</li>
            <li>Platform Independent</li>
         </ul>
         <br/>
         <h4  className="text-align-justify"><strong>Flow of Servlet Execution :</strong></h4>
         <ul className="text-align-justify">
            <li>The client sends the request to the webserver.</li>
            <li>Then, the web server receives the request.</li>
            <li>Then, the request is passed to the corresponding servlet by the webserver.</li>
            <li>Then, the servlet processes the request and generates a response in the form of output.</li>
            <li>Then, the servlet sends the response back to the webserver.</li>
            <li>Then, the response is sent back to the client by the web server and the client browser displays it on the screen.</li>
         </ul>
         <br/>
         <h4  className="text-align-justify"><strong>How Servlet handles the request ?</strong></h4>
         <ul  className="text-align-justify">
            <li>The web container maps the request with the servlet in the web.xml file.</li>
            <li>So, the web container creates request (HttpServletRequest) and response (HttpServletResponse) objects for this request.</li>
            <li>So for that request, the web container will create or allocate a thread and call the Servlet’s service() method and passes the request, response objects as arguments.</li>
            <li>Based on HTTP Request Method(Get, Post etc) sent by the client, the service() method, then decides which servlet method, doGet() or doPost() to call. </li>
            <li>The Servlet sends back the response to the client using the response object.</li>
            <li>And, after the service() method is executes, the thread dies. Then, the web container deletes the request and response objects and is ready for garbage collection.</li>
         </ul>
         <br/>
         <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
            {
               'import java.io.*;\n' +
               'import javax.servlet.*;\n' +
               '\n' +
               'public class ServletLifeCycle implements Servlet {\n' +
               '\n' +
               '  @Override\n' +
               '  public void init(ServletConfig config) throws ServletException {}\n' +
               '\n' +
               '  @Override\n' +
               '  public ServletConfig getServletConfig() {\n' +
               '    return null;\n' +
               '  }\n' +
               '\n' +
               '  @Override\n' +
               '  public void service(ServletRequest request, ServletRespnse response) throws ServletException, IOException {}\n' +
               '\n' +
               '  @Override\n' +
               '  public String getServletInfo() {\n' +
               '    return null;\n' +
               '  }\n' +
               '\n' +
               '  @Override\n' +
               '  public void destroy() {}\n' +
               '}'
            }
         </SyntaxHighlighter>
      </div>
   </WorkingOfAServletWrapper>
);

export default WorkingOfAServlet;
